<template>
    <ActiveJobs></ActiveJobs>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ActiveJobs = defineAsyncComponent(() =>
    import("../../components/GlobalPunchSystem/ActiveJobs.vue")
);

export default {
    name: "Global_Punch_Active_Jobs", //The name you are in should not equal the name of the component you are importing.
    components: { ActiveJobs, AuthLayout },
};
</script>
